import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, of, ReplaySubject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {Router} from '@angular/router';
import {delay, first, takeUntil, tap} from 'rxjs/operators';
import {Uuid} from '../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {User} from '../../../shared/interface/user';
import {UserService} from '../../../shared/services/user.service';
import {validPhoneNumber} from '../../../shared/validator/phone-validator';
import {validEmailAddress} from '../../../shared/validator/email-validator';
import {Contract} from "../../../shared/interface/contract";
import {Partner} from "../../../shared/interface/partner";
import {Ofwca} from "../../../shared/interface/ofwca";
import {FlexAlignStyleBuilder} from "@angular/flex-layout";
import {PartnerService} from "../../../shared/services/partner.service";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {Dictionary} from "../../../shared/interface/dictionary";
import {IddTrainingService} from "../../../shared/services/idd-training.service";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {IddTraining} from "../../../shared/interface/idd-training";
import {
  CONTRACT_STATUS_ACTIVE,
  CONTRACT_STATUS_DURING_TERMINATION,
  CONTRACT_STATUS_TO_TERMINATE,
  DICT_TYPE_TERMINATION_TIME,
  DYNAMIC_DICTIONARY_ASF360,
  OFWCA_STATUS_INACTIVE,
  TERMINATION_TIME_IMMEDIATELY
} from "../../../shared/services/dict.service";
import {DepartmentService} from "../../../shared/services/department.service";
import {connectableObservableDescriptor} from "rxjs/internal/observable/ConnectableObservable";
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from "../../../shared/services/auth.service";
import {$} from "protractor";
import {AngularEditorConfig} from "@kolkov/angular-editor";

@Component({
  selector: 'app-user-add',
  templateUrl: './user-add.component.html',
  styleUrls: ['./user-add.component.scss']
})
export class UserAddComponent implements OnInit, OnDestroy {

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '400px',
    minHeight: '400px',
    maxHeight: '400px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: false,
    showToolbar: false,
    placeholder: 'Wprowadź treść ...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [],
      ['fontName', 'inline-block'],
      [
        'insertVideo',
        'insertImage',
        'insertHorizontalRule'
      ]
    ]
  };

  @Input() user?: Observable<User>;
  @Input() userObject?: User;
  @Output() closeModification = new EventEmitter<any>();
  userPermissions: ReplaySubject<UserPermissions>;

  userForm: FormGroup;
  regionalIdControl: FormControl;
  departmentControl: FormControl;
  dobryAgentPartnerControl: FormControl;
  partnerToggleControl: FormControl;
  ofwcaToggleControl: FormControl;
  partnerControl: FormControl;
  ofwcaControl: FormControl;
  permissionTagControl: FormControl;
  // activeASF360Control: FormControl;
  processingRequest = false;
  formErrors: any  = {};
  partnerTagsControl: FormControl;
  asf360TagsControl: FormControl;
  // typeRadioValue = 0;
  type1 = false;
  type2 = false;
  departmentsRequired = false;
  contractCompanyId: ReplaySubject<number> = new ReplaySubject<number>(1);
  selectedContract?: Contract;
  roleControl: FormControl;
  positionDecriptionControl: FormControl;
  edit = false;
  readonly DYNAMIC_DICTIONARY_ASF360 = DYNAMIC_DICTIONARY_ASF360;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);



  constructor(
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private formHelper: FormHelperService,
    private router: Router,
    private userService: UserService,
    private partnerService: PartnerService,
    private ofwcaService: OfwcaService,
    private iddTrainingService: IddTrainingService,
    private departmentService: DepartmentService,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.userForm = fb.group({
      firstName: fb.control('', [Validators.required]),
      lastName: fb.control('', [Validators.required]),
      phoneNumber: fb.control('', [Validators.required, validPhoneNumber()]),
      email: fb.control('', [Validators.required, validEmailAddress()]),
      active: fb.control(true),
      individualPermissions: fb.control(false),
      googleAuthenticatorEnabled: fb.control(false),
      // activeASF360: this.activeASF360Control = fb.control(''),
      position: fb.control(''),
      positionDescription: this.positionDecriptionControl = fb.control(''),
      role: this.roleControl = fb.control('',[Validators.required]),
      regionalId: this.regionalIdControl = fb.control(''),
      department: this.departmentControl = fb.control(''),
      tags: this.partnerTagsControl = fb.control([]),
      tags360: this.asf360TagsControl = fb.control([]),
      partnerToggle: this.partnerToggleControl = fb.control(''),
      ofwcaToggle: this.ofwcaToggleControl = fb.control(''),
      partnerId: this.partnerControl = fb.control(''),
      ofwcaId: this.ofwcaControl = fb.control(''),
      permissionTag: this.permissionTagControl = fb.control([]),
      permissionOfwcaCompetition: fb.control(false),
      permissionPartnerCompetition: fb.control(false),
      permissionProduct: fb.control(false),
      permissionTagPartner: fb.control([]),
      permissionRegionalId: fb.control(''),
      permissionIddTrainingStatus: fb.control([]),
      permissionContractType: fb.control([]),
      permissionRegistration: fb.control([]),
      username: fb.control([]),
      smsCode: fb.control([]),
      employeeList360: fb.control(false),
      employee: fb.control(false),
      department360: fb.control(''),
      dobryAgentPartnerId: this.dobryAgentPartnerControl = fb.control([]),
    });
    // this.activeASF360Control.disable();
  }

  ngOnInit(): void {
    if (this.user) {
      this.user
        .pipe(takeUntil(this.destroyed$))
        .subscribe((user: User) => {
          this.initialize(user);
          this.userObject = user;
        });
    }

    this.partnerControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(data => {
        if (data) {
          this.partnerService.get(data)
            .subscribe((partner: Partner) => {
              this.processingRequest = true;
              this.userForm.get('smsCode').setValue(partner.settlementPassword);
              this.processingRequest = false;
            });
        } else {
          if (this.ofwcaControl.value) {
            this.ofwcaService.get(this.ofwcaControl.value)
              .subscribe((ofwca: Ofwca) => {
                if (!this.partnerToggleControl.value) {
                  this.userForm.get('smsCode').setValue(ofwca.settlementPassword);
                }
              });
          }
        }
      });

    this.ofwcaControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(data => {
        if (data) {
          this.ofwcaService.get(data)
            .subscribe((ofwca: Ofwca) => {
              this.processingRequest = true;
              this.processingRequest = false;
              if (!this.partnerToggleControl.value) {
                this.userForm.get('smsCode').setValue(ofwca.settlementPassword);
              }
            });
        }

      });

    this.partnerToggleControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(val => {
        if (!val){
          this.partnerControl.reset();
          this.partnerControl.disable();
        }else {
          this.partnerControl.enable();
        }
      });

    this.ofwcaToggleControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(val => {
        if (!val){
          this.ofwcaControl.reset();
          this.ofwcaControl.disable();
        }else {
          this.ofwcaControl.enable();
        }
      });

    this.roleControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(data => {
          this.regionalIdControl.reset();
          this.departmentControl.reset();
          this.partnerTagsControl.reset();
          this.asf360TagsControl.reset();
          this.partnerToggleControl.reset();
          this.ofwcaToggleControl.reset();
          this.partnerControl.reset();
          this.ofwcaControl.reset();
          this.permissionTagControl.reset();
        if (data === "ROLE_ASF360"){
          this.userForm.get('position').reset();
          this.departmentService.getDepartment('ASF360')
              .subscribe((val: string) => {
                this.departmentControl.setValue(val);
              });
          }else{
          this.userForm.get('smsCode').reset();
        }
        if (data === "ROLE_USER") {
          this.userForm.get('dobryAgentPartnerId').reset();
        }
      });

    // if (this.userObject.partnerId){
    //   this.type1 = true;
    //   this.partnerToggleControl.setValue(true);
    //   this.ofwcaToggleControl.setValue(false);
    // }
    // if (this.userObject.ofwcaId){
    //   this.type2 = true;
    //   this.partnerToggleControl.setValue(false);
    //   this.ofwcaToggleControl.setValue(true);
    // }
  }

  initialize(user: User): void {
    of(user)
      .pipe(
        delay(0),
        tap(() => {
          this.userForm.reset({
            firstName: user.firstName,
            lastName: user.lastName,
            phoneNumber: user.phone,
            email: user.email,
            active: user.active,
            individualPermissions: user.individualPermissions,
            googleAuthenticatorEnabled: user.googleAuthenticatorEnabled,
            // activeASF360: user.activeASF360,
            regionalId: user.regionalId,
            department: user.department?.uuid,
            tags: user.tags,
            tags360: user.tags360,
            role: user.roles[0],
            partnerId: user.partnerId ? user.partnerId : null,
            ofwcaId: user.ofwcaId ?  user.ofwcaId : null,
            partnerToggle: user.partnerId ? 1 : 0,
            ofwcaToggle: user.ofwcaId ? 1 : 0,
            permissionTag: user.permissionTag,
            // permissionOfwcaCompetition: user.permissionOfwcaCompetition,
            // permissionPartnerCompetition: user.permissionPartnerCompetition,
            // permissionProduct: user.permissionProduct,
            // permissionTagPartner: user.permissionTagPartner,
            permissionRegionalId: user.permissionRegionalId,
            // permissionIddTrainingStatus: user.permissionIddTrainingStatus,
            // permissionContractType: user.permissionContractType,
            // permissionRegistration: user.permissionRegistration,
            username: user.username,
            position: user.position,
            positionDescription: user.positionDescription,
            employeeList360: user.employeeList360,
            department360: user.department360,
            dobryAgentPartnerId: user.dobryAgentPartnerId,
            employee: user.employee,
          });
        })
      ).subscribe();
    this.userForm.get("username").setValidators([Validators.required]);
    if ( user.partnerId || user.ofwcaId ) {
      this.edit = true;
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    if (!this.userForm.valid) {
      this.userForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.userForm, this.formErrors);
    this.formErrors = {};

    this.userService.sendForm(this.userForm.getRawValue(), this.userObject?.uuid)
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snack.open(this.userObject ? 'Pomyślnie zaktualizowano użytkownika'
          : 'Pomyślnie utworzono użytkownika', '', {
          duration: 2000,
        });
        this.processingRequest = false;

        if (this.user) {
          this.closeModification.emit();
        } else {
          this.router.navigate(['/uzytkownicy/szczegoly', response.uuid]);
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open(this.userObject ? 'Podczas aktualizacji użytkownika wystąpił błąd'
          : 'Podczas tworzenia użytkownika wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.userForm, this.formErrors);
          this.snack.open(error.error.error.text, '400', {duration: 2000});
        } else {
          this.snack.open(this.userObject ? 'Podczas aktualizacji użytkownika wystąpił błąd'
            : 'Podczas tworzenia użytkownika wystąpił błąd', error.status.toString(), {
            duration: 2000,
          });
        }
      })
    ;
  }

  cancel(): void {
    if (this.user) {
      this.closeModification.emit();
    } else {
      this.router.navigate(['/uzytkownicy']);
    }
  }

  partnerChanged(partner: Partner): void {
    if (partner && !this.edit) {
      this.userForm.get('firstName').setValue(partner.fullName);
      this.userForm.get('lastName').setValue(' ');

      partner.phones.forEach((phone) => {
        if (phone.main){
          this.userForm.get('phoneNumber').setValue(phone.number);
        }
      });

      partner.emails.forEach((email) => {
        if (email.main ){
          this.userForm.get('email').setValue(email.address);
        }
      });
      // this.userForm.get('roles').setValue(['ROLA_ASF360']);
      this.departmentControl.setValidators([Validators.required]);
      this.partnerToggleControl.setValidators([Validators.required]);
      this.partnerToggleControl.updateValueAndValidity();
    }
    if (partner.owner !== null) {
      if (partner.owner.status.key !== OFWCA_STATUS_INACTIVE ){
        this.ofwcaControl.setValue(partner.owner.uuid);
        this.ofwcaToggleControl.setValue(true);
      } else  {
        this.ofwcaControl.setValue(null);
        this.ofwcaToggleControl.setValue(false);
      }
    }else{
      this.ofwcaControl.setValue(null);
      this.ofwcaToggleControl.setValue(false);
    }
  }

  ofwcaChanged(ofwca: Ofwca): void {
    if (ofwca && !this.edit && !this.partnerToggleControl.value) {
      this.userForm.get('firstName').setValue(ofwca.firstName);
      this.userForm.get('lastName').setValue(ofwca.lastName);
      this.userForm.get('phoneNumber').setValue(ofwca.phone);

      ofwca.emails.forEach((email) => {
        if (email.main ){
          this.userForm.get('email').setValue(email.address);
        }
      });
      ofwca.phones.forEach((phone) => {
        if (phone.main ){
          this.userForm.get('email').setValue(phone.number);
        }
      });

      this.departmentControl.setValidators([Validators.required]);
      this.ofwcaControl.setValidators([Validators.required]);
      this.ofwcaControl.updateValueAndValidity();
    }
  }

  onPaste(event: ClipboardEvent, short: boolean) {
    event.preventDefault();

    const clipboardData = event.clipboardData;
    let pastedText = clipboardData?.getData('text') || '';

    const plainText = pastedText.replace(/<\/?[^>]+(>|$)/g, '');

    const currentValue = this.positionDecriptionControl.value || '';

    const availableSpace = 10000 - currentValue.length;

    const textToInsert = plainText.substring(0, availableSpace);
    if (short){
      document.execCommand('insertText', false, textToInsert);
    }else
    {
      document.execCommand('insertText', false, plainText);
    }
  }

}
